import Api from './coreapi';
export default {
    typeList(){
        return new Promise((resolve) => {
            Api.request().post('customer/types').then(res => {
                if(Api.isValid(res)){
                    resolve(res.data);
                }
            });
        });
    },
    toList(filter){
        return new Promise((resolve) => {
            Api.request().post('customer/list', filter).then(res => {
                if(Api.isValid(res)){
                    resolve(res.data);
                }
            });
        });
    },
    selectAddress(filter){
        return new Promise((resolve) => {
            Api.request().post('customer/addresses', filter).then(res => {
                if(Api.isValid(res)){
                    resolve(res.data);
                }
            });
        });
    },
    delete(params){
        return new Promise(() => {
            Api.request().post('customer/delete', params).then(res => {
                if(Api.isValid(res)){
                    resolve();
                }
            });
        });
    }
}